const subTitleStyles = (theme) => ({
  root: {},
  text: {
    color: theme.palette.ink.ink70,
  },
});

export default subTitleStyles;
